import { Modal } from "react-bootstrap";
import "./investmentCalculator.css";

const DisclaimerModal = ({ setShowBanner, showBanner }) => {
  return (
    <Modal show={showBanner} onHide={() => setShowBanner(false)} closeButton size="xl">
      <Modal.Header closeButton className="birdsey-modal-header"></Modal.Header>
      <Modal.Body className="p50">
        <div class="modal-body">
          <div class="rr-head">
            Rent Range Disclaimer
          </div>
          <div class="rr-desc">
            The rental information is provided by the RentRange® business, which, like the Hubzu® business, is owned by Altisource Solutions S.a r.l. ("Altisource"). RentRange provides rental information, including rental estimates on an "as-is" basis for informational purposes only. Your use of this information is voluntary and at your sole risk. The rental information is provided in good faith based on certain information RentRange may have, but in no event shall such rental information, estimates or any other information provided create any warranty or representation. Neither the rental estimates nor any other rental information is intended to constitute, and in fact does not constitute, financial, investment, tax or legal advice by the RentRange, Hubzu or any other Altisource entity. All investment decisions carry inherent risk, and no Altisource entity shall have any liability with respect to any investment decision made based on the rental information, estimate or any other information contained herein.
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DisclaimerModal;
